import React from 'react'
import './style.scss'

export default function Button({ disabled, text, onClick }) { 
    return ( 
        <button disabled={disabled} className="btn" onClick={() => onClick()}> 
            {text}
        </button>
    )
}